import type { FaireProductEntity } from "../../entity_types/product";

export const p_29ufdzyxwq: FaireProductEntity = {
  token: "p_29ufdzyxwq",
  type: "product",
  name: "Squishy Glitter Dumpling Toy | Trendy | HOT | A016",
  brandToken: "b_vq4dxxsy59",
  brandName: "Prime Opticals",
  imageUrl:
    "https://cdn.faire.com/fastly/b40152bf6143f0ab79e65551fa59ea83ce47a77e6056bccedac05ee8c23ff366.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8a0aa9177ca5c820fe1895e30790a2d7f691d0657b19aface436e103e0d4cfcf.jpeg",
    "https://cdn.faire.com/fastly/d79a0708cd7335a81b4be9f360e150109220ad30eda2d0ef36d3e6085189c4c6.jpeg",
    "https://cdn.faire.com/fastly/c5c08947671b9a85c7b2b8b3b2445ce0d1cb07fdf1fc73000360fbc7eba9e6df.jpeg",
  ],
  priceDollars: 4.99,
  description:
    "Very trendy, hot toy! Squishy toy that every kid is looking for! Different colors in the master box of 12! Test your luck to see which color you get.\n\nATTENTION!!!! \nProduct display box may vary between orders as different batches are boxed different, we advise everyone to please open a basket to see if you got the right one! Sorry for the confusion, we are also battling this battle with our suppliers! Thank you for understanding. \n\n\n*****ATTENTION***** \nWe are aware of the recalls happening across the world for a select batch of dumplings out of the UK & NJ, we can reassure you, NONE of these dumplings in stock are part of the recall. We monitor this daily and are keeping our ears low to the ground for any news regarding all toys we sell on Faire. Thank you from your business and trust. -Prime Opticals",
  tags: [],
  msrpDollars: 9.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:41.916Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
